import styled from 'styled-components'

interface IProps {
  title: string
  description: string
}

export const DemoQuizNotice = ({ title, description }: IProps) => {
  return (
    <DemoNotice>
      <b>{title}</b>
      <span className="description">{description}</span>
    </DemoNotice>
  )
}

const DemoNotice = styled.div`
  background: #fffbe6;
  color: #b8860b;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px #0000000a;
  width: 100%;

  .description {
    text-align: center;
    max-width: 750px;
  }
`
